import React from "react";
import Popup from "../../../DesignSystem/Popups/Popup";

const ConfirmActionModal = ({
  isOpen,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
}) => (
  <Popup
    open={isOpen}
    title={title}
    description={message}
    confirmLabel={confirmLabel || "Confirm"}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default ConfirmActionModal;
